import React from 'react';
import Skeleton from 'react-loading-skeleton';

const OrdersRatingListRowSkeleton = () => {
  return (
    <div className="orders-rating-list-row  mr-4">
      <Skeleton height={30} />
    </div>
    // <div className="orders-rating-list-row orders-rating-list-row__grid-template mr-4">
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    //   <div className="orders-rating-list-row__element">
    //     <Skeleton />
    //   </div>
    // </div>
  );
};

export default OrdersRatingListRowSkeleton;
